import { render, staticRenderFns } from "./extend_info.vue?vue&type=template&id=6def1846&scoped=true&"
import script from "./extend_info.vue?vue&type=script&lang=js&"
export * from "./extend_info.vue?vue&type=script&lang=js&"
import style0 from "./extend_info.vue?vue&type=style&index=0&id=6def1846&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def1846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6def1846')) {
      api.createRecord('6def1846', component.options)
    } else {
      api.reload('6def1846', component.options)
    }
    module.hot.accept("./extend_info.vue?vue&type=template&id=6def1846&scoped=true&", function () {
      api.rerender('6def1846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/extended_info/extend_info.vue"
export default component.exports